import {
  getVerificationTitleName,
  verificationSourceType
} from "views/applications-id-report/slices/CombinedIncomeReportSlice/utils";
import { Logo } from "../../components/Logo";
import { Hide } from "shared/components/helpers/Hide";
import { Button, ButtonSize } from "shared/components";
import { ApplicationStatus } from "shared/types";
import { ResumeTooltip } from "shared/app/OnHoldResume/ResumeTooltip";
import { CombinedIncome } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/income";
import { Dispatch, SetStateAction } from "react";
import { VerifiedItem } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/verified";
import { File02Icon } from "@hugeicons-pro/core-stroke-rounded";

export const VerifiedHeader = ({
  currentItem,
  income,
  applicationStatus,
  applicationId,
  setShowReverifyIncomeModal
}: {
  currentItem?: VerifiedItem;
  income: CombinedIncome;
  applicationStatus: ApplicationStatus;
  applicationId: string | number;
  setShowReverifyIncomeModal: Dispatch<SetStateAction<number | false>>;
}) => {
  return (
    <div className="flex justify-between mb-4">
      <div className="flex gap-4 items-center">
        <Logo
          logo={
            currentItem?.data && "institution_metadata" in currentItem.data
              ? currentItem.data.institution_metadata?.logo || ""
              : ""
          }
          verified_source_type={currentItem?.income_source_type}
        />
        <div>
          <h2 className="text-base text-content-1000 font-medium mb-1">
            {getVerificationTitleName(income)}
          </h2>
          <p className="text-sm text-content-400">
            {verificationSourceType[currentItem?.income_source_type || ""] ||
              currentItem?.income_source_type}
          </p>
        </div>
      </div>

      <Hide if={income.type === "offer_letter" || currentItem?.is_archived}>
        <Button
          HugeIcon={File02Icon}
          size={ButtonSize.SM}
          disabled={applicationStatus === ApplicationStatus.OnHold}
          tooltip={
            applicationStatus === ApplicationStatus.OnHold ? (
              <ResumeTooltip applicationId={Number(applicationId)} />
            ) : undefined
          }
          onClick={() => {
            setShowReverifyIncomeModal(income.id);
          }}
          tooltipDelay={250}
          className="animate-appear"
        >
          Re-verify with documents
        </Button>
      </Hide>
    </div>
  );
};
